import { render, staticRenderFns } from "./EditFolder.vue?vue&type=template&id=57548c2f"
import script from "./EditFolder.vue?vue&type=script&lang=js"
export * from "./EditFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports